
import {
  schema, normalize
} from 'normalizr'

import omitBy from 'lodash.omitby'
import isNil from 'lodash.isnil'

// Define exercise schema
const exercisesSchema = new schema.Entity('exercises')
const exercisesListSchema = [exercisesSchema]

const solutionsSchema = new schema.Entity('solutions')
const solutionsListSchema = [solutionsSchema]

const testsSchema = new schema.Entity('tests')
const testsListSchema = [testsSchema]

export function adaptExercisesToStore({ data }) {
  const entries = normalize(data.results, exercisesListSchema)
  return {
    entries: entries.entities.exercises,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}

export function adaptExerciseToApi(exercise = {}) {
  let payload = {
    ...exercise
  }
  payload = omitBy(payload, isNil)
  delete payload.description_html
  delete payload.id
  delete payload.duration_in_seconds
  //Can send null value
  payload.instructor_id = exercise.instructor_id
  return payload
}

export function adaptExerciseToStore({ data }) {
  return {
    ...data
  }
}

export function adaptSolutionsToStore({ data }) {
  const entries = normalize(data.results, solutionsListSchema)
  return {
    entries: entries.entities.solutions,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}

export function adaptSolutionToApi(solution = {}) {
  let payload = {
    ...solution
  }
  payload = omitBy(payload, isNil)
  return payload
}

export function adaptSolutionToStore({ data }) {
  return {
    ...data
  }
}

export function adaptTestsToStore({ data }) {
  const entries = normalize(data.results, testsListSchema)
  return {
    entries: entries.entities.tests,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}

export function adaptTestToApi(test = {}) {
  let payload = {
    ...test
  }
  payload = omitBy(payload, isNil)
  return payload
}

export function adaptTestToStore({ data }) {
  return {
    ...data
  }
}